/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ShippingAndBilling.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Avanthi G(E860178)
 *
 * @Date                : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 05, 2019
 * Description   : Updated code for ASDS-685 with static data and styles.
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 05, 2019
 * Description   : Updated code for ASDS-686, implemented functionality for showing select Account ,the change account on click
 *
 * By            : H352615
 * On            : Aug 14, 2019.
 * Description   : ASDS-949 - Generic Loader throught application.
 *
 * By            : H224423
 * On            : Oct 03, 2019.
 * Description   : ASDS-1478 - Dancing loader issue fix. Removed unused GlobalLoader function. Renamed inlineClassName to inlineclassname to avoid mismatch with DOM tags.
 *
 * By            : h267743
 * On            : Oct 10, 2019.
 * Description   : ASDS-1477 - added z-index for loaders
 ******************************************************************************/

import React, { ReactText } from "react";
import { Loader } from "@scuf/common";
import "./GenericLoader.module.css";

const defaults = {
  className: "generic-loader",
  inverted: false,
  loading: false,
  minHeight: 100,
  overlayColor: "rgba(0,0,0,0.2)",
  overlayOpacity: 0.5,
  text: "Please Wait"
};

interface ILoaderProps {
  className?: string;
  inverted?: boolean;
  loading?: boolean;
  minHeight?: ReactText;
  overlayColor?: string;
  overlayOpacity?: number;
  text?: string;
  zIndex?: number;
}

interface IInLineLoaderProps {
  children?: React.ReactNode;
  inlineclassname?: string;
}

export default function GenericLoader(props: ILoaderProps) {
  if (props.inverted) {
    return (
      <div style={{ zIndex: props.zIndex || 9 }}>
        <Loader {...defaults} {...props} inverted>
          <div className="placeholder" />
        </Loader>
      </div>
    );
  }
  return (
    <div style={{ zIndex: props.zIndex || 9 }}>
      <Loader {...defaults} {...props}>
        <div className="placeholder" />
      </Loader>
    </div>
  );
}

export function InLineLoader(props: ILoaderProps & IInLineLoaderProps) {
  return (
    <div
      style={{ position: "relative" }}
      className={props.inlineclassname || ""}
    >
      {props.children}
      <GenericLoader {...props} />
    </div>
  );
}
